// extracted by mini-css-extract-plugin
export default {"video-container":"video__video-container--f0odK","video-iframe":"video__video-iframe--jYHiD"};